import JobApi from '@/services/api/job/job.js'
import JobDefinitionAPI from '@/services/api/job/job_definition.js'
import PoolAPI from '@/services/api/job/pool'
import StatusAPI from '@/services/api/job/status'
import JobPoolStatus from '@/services/api/job/job_pool_status.js'
import NextStatus from '@/services/api/job/next_status.js'
import CommentAPI from '@/services/api/job/comment.js'
import MutationTypes from './mutations-types'
import ActionTypes from './actions-types'

export default {
  [ActionTypes.GET_ALL_JOBS]({ commit }, options = {}) {
    const { skipJobsCommit = false, ...requestOptions } = options

    if (!skipJobsCommit) {
      commit(MutationTypes.SET_JOBS, [])
    }

    return JobApi.getAllJobs(requestOptions)
      .then(response => {
        if (!skipJobsCommit) {
          commit(MutationTypes.SET_JOBS, response.data.items)
        }

        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.GET_JOB]({ }, jobId) {
    return JobApi.getJob(jobId)
      .then(response => {
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.SEARCH_JOB]({  }, options) {
    return JobApi.searchJob(options)
      .then(response => {
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  async [ActionTypes.MOVE_TO_POOL]({ commit }, params) {
    if (params.pool_title) {
      const history = "O <b>job</b> foi enviado para a pool <b>" + params.pool_title + "</b>"
      const commentData = {
        job_id: params.job_id,
        message: history,
        comment_type: 2
      }
      await CommentAPI.createComment(commentData)
    }

    return JobApi.moveJobToPool(params)
      .then(response => {
        const updateData = {...response.data, [response.data.pool_type]: response.data.user_group_id}

        commit(MutationTypes.UPDATE_JOB, updateData)

        return updateData
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.CHANGE_SLOT]({ commit }, params) {
    return JobApi.changeJobSlot(params)
      .then(response => {
        const data = response.data

        if (data.length > 0) {
          const startDate = data[0].start_date
          const endDate = data[0].end_date
          const history = "O <b>período</b> do job foi alterado para <b>" + startDate + "</b> até </b>" + endDate + "</b>"
          const commentData = {
            job_id: params.job_id,
            message: history,
            comment_type: 2
          }
          CommentAPI.createComment(commentData)
        }

        if (data.length > 0) {
          data.forEach(job => {
            commit(MutationTypes.UPDATE_JOB, job)
          })
        }

        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.DELETE_JOB]({ commit }, jobId) {
    return JobApi.deleteJob(jobId)
      .then(response => {
        commit(MutationTypes.REMOVE_JOB, jobId)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.CREATE_SUBTASK]({ commit }, params) {
    return JobApi.createSubtask(params)
      .then(response => {
        const subtask = response.data

        const history = "A subtarefa <b>" + subtask.name + "</b> foi criada."
        const commentData = {
          job_id: params.job_id,
          message: history,
          comment_type: 2
        }

        CommentAPI.createComment(commentData)

        commit(MutationTypes.ADD_JOB, subtask)

        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.FINISH_SUBTASK]({ commit }, {jobId, params}) {
    return JobApi.finishSubtask(jobId)
      .then(response => {
        const history = "A subtarefa <b>" + params.name + "</b> foi encerrada."
        const commentData = {
          job_id: jobId,
          message: history,
          comment_type: 2
        }

        CommentAPI.createComment(commentData)

        const updateData = {
          job_id: jobId,
          readonly: true
        }

        commit(MutationTypes.UPDATE_JOB, updateData)
        commit(MutationTypes.REMOVE_JOB, jobId)

        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.FINISH_JOB]({ commit }, {jobId, params}) {
    return JobApi.finishJob(jobId)
      .then(response => {
        const history = "O job <b>" + params.name + "</b> foi encerrado."
        const commentData = {
          job_id: jobId,
          message: history,
          comment_type: 2
        }

        CommentAPI.createComment(commentData)

        const updateData = {
          job_id: jobId,
          readonly: true
        }

        commit(MutationTypes.UPDATE_JOB, updateData)
        commit(MutationTypes.REMOVE_SUBTASKS_BY_PARENT_JOB_ID, jobId)
        commit(MutationTypes.REMOVE_JOB, jobId)

        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.REOPEN_JOB]({ commit }, jobId) {
    return JobApi.reopenJob(jobId)
      .then(response => {
        commit(MutationTypes.UPDATE_JOB, {
          job_id: jobId,
          readonly: false,
        })

        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.GET_ALL_JOB_DEFINITIONS]({ commit }, options = {}) {
    commit(MutationTypes.SET_JOB_DEFINITIONS, [])
    return JobDefinitionAPI.getAllJobDefinitions(options)
      .then(response => {
        commit(MutationTypes.SET_JOB_DEFINITIONS, response.data.items || [])
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.GET_JOB_DEFINITION]({ }, jobDefinitionId) {
    return JobDefinitionAPI.getJobDefinition(jobDefinitionId)
      .then(response => {
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.CREATE_JOB_DEFINITION]({ commit }, data) {
    return JobDefinitionAPI.createJobDefinition(data)
      .then(response => {
        commit(MutationTypes.ADD_JOB_DEFINITION, response.data)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.UPDATE_JOB_DEFINITION]({ commit }, { id, data }) {
    return JobDefinitionAPI.updateJobDefinition(id, data)
      .then(response => {
        commit(MutationTypes.UPDATE_JOB_DEFINITION, response.data)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.DELETE_JOB_DEFINITION]({ commit }, jobDefinitionId) {
    return JobDefinitionAPI.deleteJobDefinition(jobDefinitionId)
      .then(response => {
        commit(MutationTypes.REMOVE_JOB_DEFINITION, jobDefinitionId)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.GET_ALL_POOLS]({}, params) {
    return PoolAPI.getAllPools(params)
      .then(response => response.data)
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.GET_ALL_STATUSES]({}, params) {
    return StatusAPI.getAllStatuses(params)
      .then(response => response.data)
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.GET_ALL_JOB_POOL_STATUSES]({ }, params) {
    return JobPoolStatus.getAllJobPoolStatuses(params)
      .then(response => response.data.items.filter(jps => jps.job_definition_id == params.jobDefinitionId))
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.CREATE_JOB_POOL_STATUS]({ }, data) {
    return JobPoolStatus.createJobPoolStatus(data)
      .then(response => {
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.UPDATE_JOB_POOL_STATUS]({ }, { id, data }) {
    return JobPoolStatus.updateJobPoolStatus(id, data)
      .then(response => {
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.DELETE_JOB_POOL_STATUS]({ }, id) {
    return JobPoolStatus.deleteJobPoolStatus(id)
      .then(response => {
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.GET_NEXT_STATUSES_BY_CURRENT]({ }, {id, params}) {
    return NextStatus.getNextStatusesByCurrentStatus(id, params)
      .then(response => {
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.CREATE_NEXT_STATUS]({ }, data) {
    return NextStatus.createNextStatus(data)
      .then(response => {
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },

  [ActionTypes.DELETE_NEXT_STATUS]({ }, data) {
    return NextStatus.deleteNextStatus(data)
      .then(response => {
        return response.data
      })
      .catch((error) => Promise.reject(error))
  },
}
